import type { AppRouter } from "@sunfish/api";
import { createTRPCReact } from "@trpc/react-query";

export const trpc = createTRPCReact<AppRouter>();
export const useTRPC = () => trpc;
